<div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>
